const apiUrls = {
  dev: 'http://localhost:3333',
  prod: process.env.REACT_APP_API,
}

export const config = {
  API_URL: apiUrls[process.env.REACT_APP_HOST_ENV || 'dev'],
  NAMESPACE: 'campinas',
  OPERATOR_KEY: 'operator',
  PARAMETERS_KEY: 'parameters',
  TOKEN_KEY: 'tk',
  SA_TOKEN_KEY: 'satk',
}
